import Task from "../task";
import ACLProject from "../../../gd/access-control/project/project";
import canCreateTask from "../../project/access/create-task";

// const debug = "TaskAccessControl"
const debug = false

export class TaskAccessControl {

    private task : Task

    constructor(task:Task) {
        this.task = task
    }

    get isTaskUser() {
        if (
            this.task.actionRequiredUserId === gd.user.id ||
            this.task.assignedToUserId === gd.user.id ||
            this.task.createdByUserId === gd.user.id
        ) return true

        if (this.task.users) {
            // not implemented yet
        }

        return false
    }

    get hasAccessAndNotTemplate():boolean {

        const project = gd.session.projects.get(this.task.projectId)!
        if (project.isTemplate) return false

        if (ACLProject.hasStandardAccess(this.task.projectId)) return true

        if (this.isTaskUser) return true

        return false
    }

    get hasAccessAndTaskOpenAndNotTemplate():boolean {

        // libo full|standard projects access libo task access ?

        if (this.task.isClosed) return false

        const project = gd.session.projects.get(this.task.projectId)!

        if (project.isTemplate) return false

        if (ACLProject.hasStandardAccess(this.task.projectId)) return true

        if (this.isTaskUser) return true

        return false
    }


    // this is a very default check
    get hasAccessAndTaskOpen():boolean {

        // libo full|standard projects access libo task access ?

        if (this.task.isClosed) return false

        if (ACLProject.hasStandardAccess(this.task.projectId)) return true

        if (this.isTaskUser) return true

        return false
    }

    get hasAccess():boolean {

        // libo full|standard projects access libo task access ?

        if (ACLProject.hasStandardAccess(this.task.projectId)) return true

        if (this.isTaskUser) return true

        return false
    }

    get canDelete():boolean {

        if (ACLProject.hasFullAccess(this.task.projectId)) {
            debug && console.log("has full access")
            return true
        }

        // Experimental allow user delete task if they created it
        if (this.task.createdByUserId === gd.user.id) {
            debug && console.log("task owner")
            return true
        }

        // Old code below

        // let res = false;
        // if (projectId) {
        //
        //     let projectAccess = 0, companyId, sProject;
        //     try {
        //         sProject = project ? project : gd.session.projects.get(projectId);
        //         projectAccess = sProject.access;
        //         companyId = sProject.companyId;
        //     } catch(e) {
        //         console.error("Check rules task canDelete error:", projectId, sProject);
        //     }
        //
        //     if (!gd.session.companies.get(companyId)) return false;
        //
        //     // let organizationRole = gd.session.companies.get(companyId).role;
        //
        //     res = (projectAccess >= gd.const.project.access.FULL/* ||
        //             organizationRole >= gd.const.companyRole.MANAGER*/);
        // }


        return false
    }

    get canChangeDeadline():boolean {
        return this.hasAccessAndTaskOpen
    }

    get canChangeStartDate():boolean {
        return this.hasAccessAndTaskOpen
    }

    get canChangeEndDate():boolean {
        return this.hasAccessAndTaskOpen
    }

    get canChangeDuration():boolean {
        return this.hasAccessAndTaskOpen
    }

    get canChangeScheduleDate():boolean {
        return this.hasAccessAndTaskOpen
    }

    get canChangeTaskEstimate():boolean {
        return this.hasAccessAndTaskOpen
    }

    get canChangeTaskProgress():boolean {
        return this.hasAccessAndTaskOpen
    }

    get canChangePriority():boolean {
        return this.hasAccessAndTaskOpen
    }

    get canChangeActionRequired():boolean {
        return this.hasAccessAndTaskOpenAndNotTemplate
        // return this.hasAccessAndTaskOpen
    }

    get canChangeAssignedTo():boolean {
        return this.hasAccessAndTaskOpenAndNotTemplate
        // return this.hasAccessAndTaskOpen
    }

    get canChangeDependency():boolean {
        return this.hasAccessAndTaskOpen
    }
    get canChangeDurations():boolean {
        return this.hasAccessAndTaskOpen
    }

    get canChangeStoryPoints():boolean {
        return this.hasAccessAndTaskOpen
    }

    get canChangeEstimate():boolean {
        return this.hasAccessAndTaskOpen
    }

    get canChangeStatus():boolean {
        return this.hasAccessAndNotTemplate
    }

    get canChangeTaskType():boolean {
        return this.hasAccess
    }

    get canChangeCustomFields():boolean {
        return true // hmmmm
    }

    get canAddProjectUser():boolean {
        return this.hasAccessAndTaskOpenAndNotTemplate && ACLProject.canAddUsers(this.task.projectId)
    }

    get canAddExpense() {
        return this.hasAccess
    }

    get canAddSubtask():boolean {

        if (this.task.isSubtask) return false // no sub sub tasks

        if (this.task.isClosed) return false // no add to closed items

        return canCreateTask(gd.session.projects.get(this.task.projectId)!)
    }

    get canRename(): boolean {
        return this.hasAccess
    }

    get canMove(): boolean {
        return this.hasAccess
    }

    get canChangeType(): boolean {
        return this.hasAccess
    }

    get canAddTimeTracking(): boolean {
        return this.hasAccess
    }

    get canAddTimeReport(): boolean {
        return this.hasAccess
    }

    get canAddReminder(): boolean {
        return this.hasAccess
    }

    get canDuplicate(): boolean {
        if (this.task.isClosed) return false // no add to closed items

        return canCreateTask(gd.session.projects.get(this.task.projectId)!)
    }

    get canAddRecurrence(): boolean {
        return this.hasAccess
    }


}
